import { t } from 'i18next';
import { cn } from '../../../lib/styles';
import type { TextSize, TextVariant } from '../text/types';
import type { TextLinkProps } from './types';

const SIZE_MAP: Record<TextSize, string> = {
  sm: 'text-xs',
  md: 'text-sm',
  lg: 'text-xl',
  xl: 'text-3xl',
};

const VARIANT_MAP: Record<TextVariant, string> = {
  primary: 'text-spark-primary-accent hover:brightness-125',
  secondary: 'text-spark-text-secondary hover:text-spark-text-primary',
};

// `appearance-none border-0 bg-transparent p-0` neutralises the default button
// chrome so the rendered <button> reads as inline text rather than a UI control.
const BASE =
  'inline cursor-pointer underline underline-offset-2 font-medium rounded-sm ' +
  'appearance-none border-0 bg-transparent p-0 ' +
  'focus:outline-hidden focus-visible:ring-2 focus-visible:ring-spark-primary-accent focus-visible:ring-offset-2 focus-visible:ring-offset-spark-surface';

export function TextLink(props: TextLinkProps) {
  const { size = 'md', variant = 'primary' } = props;
  const className = cn(BASE, SIZE_MAP[size], VARIANT_MAP[variant]);

  if (props.href !== undefined) {
    return (
      <a
        href={props.href}
        aria-label={props.ariaLabel}
        target={props.external ? '_blank' : undefined}
        rel={props.external ? 'noopener noreferrer' : undefined}
        className={className}
      >
        {props.children}
        {props.external && <span className="sr-only">{t('aria:opens_new_tab')}</span>}
      </a>
    );
  }

  return (
    <button
      type="button"
      onClick={props.onClick}
      aria-label={props.ariaLabel}
      className={className}
    >
      {props.children}
    </button>
  );
}
